const dictionary = {}

export default dictionary
